import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTripadvisor } from "react-icons/fa";
import "./NewFooter.css";
import { s3_url } from "common/constants";

const NewFooter: React.FC = () => {
  return (
    <footer className="lumen-footer">
      <div className="lumen-footer-top">
        <Container>
          <Row className="align-items-start gy-4">
            <Col md={3} className="footer-col footer-col-links">
              <ul className="footer-links">
                <li>
                  <Link to="/izjava-privatnosti">Izjava o privatnosti</Link>
                </li>
                <li>
                  <Link to="/politika-privatnosti">Politika privatnosti</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Politika kolačića</Link>
                </li>
                <li>
                  <Link to="/opci-uvjeti">Opći uvjeti</Link>
                </li>
                <li>
                  <Link to="/sigurnost-placanja">
                    Sigurnost plaćanja kreditnim karticama
                  </Link>
                </li>
              </ul>
            </Col>

            <Col md={5} className="footer-col footer-col-contact text-center">
              <h5>Kontakt</h5>
              <address className="mb-0">
                Obrt za poduke "Lumen" vl. Karmen Dasović
                <br />
                upisan u Obrtni registar Republike Hrvatske
                <br />
                OIB: 02593652259
                <br />
                Porezni broj (PDV ID): HR02593652259
                <br />
                Matični broj: 90285697
                <br />
                <span className="footer-contact-gap" aria-hidden="true" />
                Email:{" "}
                <a
                  href="mailto:info@lumenpoduke.com"
                  style={{ textDecoration: "none" }}
                >
                  info@lumenpoduke.com
                </a>
                <br />
                Telefon:{" "}
                <a href="tel:+385098257119" style={{ textDecoration: "none" }}>
                  +385 098 257 119
                </a>
                <br />
                Adresa: Ul. Fiorella La Guardia 12, 51000, Rijeka, Hrvatska
              </address>
            </Col>

            <Col md={4} className="footer-col footer-col-payments">
              <h5 className="footer-payments-title">Načini plaćanja</h5>
              <div className="footer-payments">
                <a
                  href="https://www.mastercard.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${s3_url}/img/footer/mc_vrt_opt_pos_73_3x.png`}
                    alt="Mastercard"
                  />
                </a>
                <a
                  href="https://brand.mastercard.com/brandcenter/more-about-our-brands.html"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${s3_url}/img/footer/ms_vrt_opt_pos_73_3x.png`}
                    alt="Maestro"
                  />
                </a>
                <a
                  href="https://www.visaeurope.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${s3_url}/img/footer/Visa 2015 50.gif`}
                    alt="Visa"
                  />
                </a>
                <img
                  src={`${s3_url}/img/footer/visa-secure-blk_300dpi.jpg`}
                  alt="Visa Secure"
                />
                <img
                  src={`${s3_url}/img/footer/mc_idcheck_hrz_rgb_pos.png`}
                  alt="MC ID Check"
                />
                <a
                  href="https://www.monri.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={`${s3_url}/img/footer/monri_footer.png`}
                    alt="Monri"
                  />
                </a>
              </div>
              <div className="socials mt-3">
                <a
                  href="https://www.facebook.com/lumenpoduke1"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://www.instagram.com/lumenpoduke/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.tripadvisor.com/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Tripadvisor"
                >
                  <FaTripadvisor />
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default NewFooter;
